import { FEE_MODE } from 'Data/constants.js'

export function getView(fee_mode, fee_eligible) {
  return fee_mode === FEE_MODE.SURCHARGE && fee_eligible
}
